module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "jump_to_top_4"
    }
  }, [_vm._v("Heidis Lehr- und Wanderjahre")]), _vm._v(" "), _c('p', {
    staticClass: "bildabsatz"
  }, [_c('span', {
    staticClass: "bilderrahmen"
  }, [_c('img', {
    staticClass: "bild_ohne_rahmen",
    attrs: {
      "alt": "Bild: 054_Heidi_003.jpg",
      "src": "media/054_Heidi_003.jpg",
      "title": ""
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04365693","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sec000004.vue
// module id = 66
// module chunks = 0